import { COLOR_CHART_400, COLOR_CHART_500 } from '@eleveo/foundation';

import { ReportsKpiType, Values } from '../../types';

export const NO_VALUE_LABEL = '-';

type KpiOptions = {
  color: string;
  nameKey: string;
  type: Values<typeof ReportsKpiType>;
};

export const ADHERENCE_KPI_PROPS: KpiOptions = {
  color: COLOR_CHART_400,
  nameKey: 'scheduleAdherence.adherence',
  type: ReportsKpiType.ADHERENCE,
} as const;

export const CONFORMANCE_KPI_PROPS: KpiOptions = {
  color: COLOR_CHART_500,
  nameKey: 'scheduleAdherence.conformance',
  type: ReportsKpiType.CONFORMANCE,
} as const;

export const KPI_OPTIONS_TO_FILTER = [ADHERENCE_KPI_PROPS, CONFORMANCE_KPI_PROPS];

export const KPI_OPTIONS_PROPS = {
  [ADHERENCE_KPI_PROPS.type]: ADHERENCE_KPI_PROPS,
  [CONFORMANCE_KPI_PROPS.type]: CONFORMANCE_KPI_PROPS,
};

export const REPORTS_GRANULARITY_TYPES = {
  users: 'users',
  teams: 'teams',
} as const;

export const REPORTS_EXPORT_TYPES = {
  raw: 'raw',
  statistics: 'statistics',
} as const;
